var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPlus = function SvgPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 9 9",
    stroke: "#b6bbcc",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4.5 -4.5)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "a",
    y2: 8,
    transform: "translate(9 5)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x2: 8,
    transform: "translate(5 9)"
  }))));
};
export default SvgPlus;